import React, { useEffect, useState } from 'react';
import { Prompt, useHistory, useRouteMatch } from 'react-router-dom';
import { FaSave, FaSpinner } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { FormBuilder, FormStateBuilder } from '../../../../components/FormBuilder';
import useAlertNotification from '../../../../context/AlertNotificationContext';
import ErrorRequestService from '../../../../services/errorRequest';
import CargaHorariaValidation from '../../../../services/validation/CargaHorariaValidation';
import CargaHorariaApiService from '../../../../services/api/CargaHorariaApiService';
import PageContainer from '../../../../components/PageContainer';
import Loading from '../../../../components/Loading';
import CargaHorariaNewInfo from './CargaHorariaNewInfo';

function CargaHorariaNew(props) {
    // CONTEXT
    const history = useHistory();
    const match = useRouteMatch();
    const alert = useAlertNotification();

    // STATE
    const [formFields, setFormFields] = useState({});
    const [formData, setFormData] = useState({});
    const [initialData, setInitialData] = useState({});
    const [isEdited, setIsEdited] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    // FUNCTIONS
    const isFormEdited = () => {
        const filledFields = [] 
        Object.keys(formData).forEach(item => {
            if (formData[item]) {
                filledFields.push(formData[item]);
            }
        });
        
        const isFormFilled = filledFields.length > 0;
        return isFormFilled;
    }

    const askForLeave = (cbPositive, cbNegative=()=>{}) => {
        if (cbPositive instanceof Function) {
            const msg = 'Foram adicionados dados!\nDeseja realmente sair e perdê-los?';
            const leave = window.confirm(msg);
            
            if (leave) cbPositive();
            else cbNegative();
        }   
        return false;
    }
    
    const saveForm = async() => {
        try {
            setIsSaving(true);
            // valida os dados preenchidos
            const validation = await CargaHorariaValidation.validate(formData);
            if (!validation.isValid) {
                alert.error("Erros no formulário!");
                setIsSaving(false);
                return;
            }
            
            // se ok, enviar dados p/ API
            const result = await CargaHorariaApiService.createNew(formData);

            if (result) {
                const { insertId } = result.data;
                setIsEdited(false);
                alert.success("Criado nova carga horária codigo: "+ insertId);
                history.push(`${match.path.replace('/new','')}/${insertId}`);
                //history.push( match.path.replace('/new','') );
            }
        }
        catch (err) {
            const errorService = new ErrorRequestService(err);
            const errorMsg = errorService.getErrors(); 
            console.log(errorMsg);
            alert.error(errorMsg);
        }finally {
            setIsSaving(false);
        }
    }

    const handleCancel = () => {
        if (isEdited) {
            askForLeave(() => {
                setIsEdited(false);
                history.goBack()
            });
            return;
        }
        history.goBack();
    }

    const onChange = (ev) => {
        const { value, name } = ev.target;
        const newform = {...formData, [name]: value};
        setFormData(newform);
    }

    const onEdit = () => {
        if (isFormEdited() && !isEdited) {
            setIsEdited(true);
        }
    }

    const onStart = () => {
        const getData = async () => {
            try {
                setIsLoading(true);
                const formFields = await CargaHorariaNewInfo.getFormFields();
                const initialData = FormStateBuilder(formFields);
                setFormFields( formFields );
                setFormData( initialData );
                setInitialData( initialData );
            }
            catch (err) {
                const errorService = new ErrorRequestService(err);
                const errorMsg = errorService.getErrors(); 
                console.log(errorMsg);
                alert.error(errorMsg);
            }
            finally {
                setIsLoading(false);
            }
        }
        getData();
    }

    // USEEFFECTS
    useEffect(onStart, []);
    useEffect(onEdit, [formData])

    const actions = [
        { 
            label: isSaving ? 'Salvando...' : 'Salvar',
            icon: isSaving ? <FaSpinner /> : <FaSave />,
            color: 'success',
            type: 'button',
            disabled: isSaving,
            onClick: saveForm
        },
        { 
            label: 'Cancelar',
            icon: <MdClose /> ,
            color: 'danger',
            type: 'button',
            disabled: isSaving,
            onClick: handleCancel
        },
    ]
    
    const title = `Nova Carga Horária`;

    return (
        <PageContainer
            title={title}
            actions={actions}
        >
            { isLoading 
                ? <Loading message="Carregando..." />
                : ( initialData && 
                    <FormBuilder 
                        formFields={formFields}
                        formData={formData}
                        onChange={onChange}
                        schema={CargaHorariaValidation.schema}
                        initialValues={initialData}
                        disabledForm={isSaving}
                    />
                )
            }
            
            <Prompt
                when={isEdited}
                message={location => askForLeave(() => {
                    setIsEdited(false);
                    setTimeout(() => {
                        history.push(location.pathname);
                    }, 100);
                })}
            />
        </PageContainer>
    )
}

export default CargaHorariaNew;
